import axios, { AxiosError } from "axios";
import { SERVICEURL, keycloakLogin } from "../appconfig";

const logoutChannel = new BroadcastChannel("logout");

export const decodeTokenPayload = (token: string): Record<string, unknown> | null => {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

/**
 * Token'ın süresi dolmuş mu kontrol eder.
 * Token yoksa veya exp yoksa true döner.
 */
export const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true;
  const payload = decodeTokenPayload(token);
  if (!payload || typeof payload.exp !== "number") return true;
  // 10 saniyelik buffer — sunucu saati farkına karşı
  return Date.now() >= (payload.exp - 10) * 1000;
};

/**
 * Token'ın kaç milisaniye sonra dolacağını döner.
 * Süresi dolmuş veya token yoksa null döner.
 */
export const getTokenExpiryMs = (token: string | null): number | null => {
  if (!token) return null;
  const payload = decodeTokenPayload(token);
  if (!payload || typeof payload.exp !== "number") return null;
  const ms = payload.exp * 1000 - Date.now();
  return ms > 0 ? ms : null;
};

/**
 * Kullanıcıyı oturumdan çıkarır.
 * Keycloak aktifse sunucuya çıkış isteği atar, sonra localStorage temizlenir.
 */
export const logOut = async (): Promise<void> => {
  if (keycloakLogin) {
    const mytoken = localStorage.getItem("token");
    await axios
      .post(SERVICEURL + "api/Home/LogoutWithKeycloak", null, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + mytoken,
        },
      })
      .catch((error: AxiosError) => {
        console.log(error.message);
      });
  }

  logoutChannel.postMessage("Logout");
  localStorage.removeItem("token");
  localStorage.removeItem("roles");
  localStorage.removeItem("memberId");
  localStorage.removeItem("userName");
  window.location.href = window.location.origin + (keycloakLogin ? "" : "/login");
};

/**
 * Diğer sekmelerdeki logout mesajını dinler ve o sekmelerde de çıkış yapar.
 */
export const logoutAllTabs = (): void => {
  logoutChannel.onmessage = async () => {
    await logOut();
    logoutChannel.close();
  };
};

/** localStorage'daki oturum açmış kullanıcı member Guid'i (boşsa null). */
export const getStoredMemberId = (): string | null => {
  const id = localStorage.getItem("memberId")?.trim();
  return id && id !== "0" ? id : null;
};

/**
 * JWT içindeki userId claim'ini localStorage memberId olarak yazar.
 * Keycloak ve legacy login sonrası çağrılmalı.
 */
export const syncMemberIdFromToken = (token?: string | null): void => {
  const activeToken = token ?? localStorage.getItem("token");
  if (!activeToken) return;

  const payload = decodeTokenPayload(activeToken);
  if (!payload) return;

  const userId = payload.userId ?? payload.userID;
  if (typeof userId === "string" && userId.trim().length > 0) {
    localStorage.setItem("memberId", userId.trim());
  }
};
